export const EXPERIENCE_CONFIG = Object.freeze({
   introEnabled: true,
   demoInactivityMs: 300000,
   demoHotspotDurationMs: 120000,
   modelPath: 'models/Flüssigboden_interaktiveÜbersicht.glb',
   cacheBustModel: true,
   lilGUIEnabled: false,
});
